/**
 * index.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize console capture as early as possible
// Note: consoleCapture auto-starts when imported, but we explicitly call start()
// to ensure it's initialized. The start() method prevents duplicate initialization.
import consoleCapture from './utils/consoleCapture';
consoleCapture.start();

// PayPal checkout loads cross-origin scripts/iframes that often report the generic
// "Script error." in dev — hide that noise from the CRA error overlay only.
if (process.env.NODE_ENV === 'development') {
  window.addEventListener(
    'error',
    (event) => {
      if (event.message !== 'Script error.') return;
      const src = event.filename || '';
      if (!src || /paypal/i.test(src)) {
        event.stopImmediatePropagation();
        console.warn('[checkout] Ignored cross-origin PayPal script message in dev.');
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the PWA Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((registration) => {
      console.log('SW registration successful with scope: ', registration.scope);
    }).catch((err) => {
      console.log('SW registration failed: ', err);
    });
  });
}
